
/*
 * This file consolidates the global default GCC polyfills
 * It also serves as a lookup list for the Grunt task 'gcc'
 */

var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.polyfills={};
$jscomp.propertyToPolyfillSymbol={};
$jscomp.generator={};

$jscomp.ASSUME_ES5 = !1;
$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$jscomp.ASSUME_NO_NATIVE_SET = !1;
$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$jscomp.ISOLATE_POLYFILLS = !1;
$jscomp.FORCE_POLYFILL_PROMISE = !1;
$jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
$jscomp.IS_SYMBOL_NATIVE = "function"===typeof Symbol && "symbol" === typeof Symbol( "x" );
$jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
$jscomp.POLYFILL_PREFIX="$jscp$";

// createTemplateTagFirstArg
$jscomp.createTemplateTagFirstArg = function( a ) {
    return a.raw = a;
};

// createTemplateTagFirstArgWithRaw
$jscomp.createTemplateTagFirstArgWithRaw = function( a, b ) {
    a.raw = b;
    return a;
};

// defineProperty
// global.Object.defineProperties
$jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function( a, b, c ) {
    if( a == Array.prototype || a == Object.prototype )
        return a;

    a[b] = c.value;
    return a;
};

// getGlobal
$jscomp.getGlobal = function( a ) {
    a = ["object" == typeof globalThis && globalThis, a, "object" == typeof window && window, "object" == typeof self && self, "object" == typeof global && global];

    for( var b = 0; b < a.length; ++b )
    {
        var c = a[b];

        if( c && c.Math == Math )
            return c;
    }

    throw Error( "Cannot find global object" );
};

$jscomp.global = $jscomp.getGlobal( this );

var $jscomp$lookupPolyfilledValue = function( a, b, c ) {
    if( !c || null != a )
    {
        c = $jscomp.propertyToPolyfillSymbol[b];

        if( null == c )
            return a[b];

        c = a[c];

        return void 0 !== c ? c : a[b];
    }
};

// polyfill
$jscomp.polyfill = function( a, b, c, d ) {
    b && ( $jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated( a, b, c, d ) : $jscomp.polyfillUnisolated( a, b, c, d ) );
};

// polyfillUnisolated
$jscomp.polyfillUnisolated = function( a, b, c, d ) {
    c = $jscomp.global;
    a = a.split( "." );

    for( d=0; d < a.length-1; d++ )
    {
        var e = a[d];

        if( !( e in c ) )
            return;

        c = c[e];
    }

    a = a[a.length-1];
    d = c[a];
    b = b( d );
    b != d && null != b && $jscomp.defineProperty( c, a, {
        configurable:!0,
        writable:!0,
        value:b
    });
};

// polyfillIsolated
$jscomp.polyfillIsolated = function( a, b, c, d ) {
    var e = a.split( "." );
    a = 1 === e.length;
    d = e[0];
    d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;

    for( var f = 0; f < e.length-1; f++ )
    {
        var h = e[f];

        if( !( h in d ) )
            return;

        d = d[h];
    }

    e = e[e.length-1];
    c = $jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
    b = b( c );
    null != b && ( a ? $jscomp.defineProperty( $jscomp.polyfills, e, {
        configurable:!0,
        writable:!0,
        value:b
    }) : b !== c && ( void 0 === $jscomp.propertyToPolyfillSymbol[e] && ( c = 1E9*Math.random() >>> 0,
        $jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol( e ) : $jscomp.POLYFILL_PREFIX+c+"$"+e ),
        $jscomp.defineProperty( d, $jscomp.propertyToPolyfillSymbol[e], {
            configurable:!0,
            writable:!0,
            value:b
        })
    ));
};

// underscoreProtoCanBeSet
$jscomp.underscoreProtoCanBeSet = function() {
    var a = {
        a:!0
    },
        b={};

    try {
        return b.__proto__ = a, b.a;
    }
    catch( c )
    {
    }

    return !1;
};

// setPrototypeOf
$jscomp.setPrototypeOf = $jscomp.TRUST_ES6_POLYFILLS && "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf : $jscomp.underscoreProtoCanBeSet() ? function( a, b ) {
    a.__proto__ = b;

    if( a.__proto__ !== b )
        throw new TypeError( a + " is not extensible" );
    
    return a;
} : null;

// arrayIteratorImpl
$jscomp.arrayIteratorImpl = function( a ) {
    var b = 0;
    return function() {
        return b < a.length ? {
            done: !1,
            value: a[b++]
        } : {
            done: !0
        };
    };
};

// arrayIterator
$jscomp.arrayIterator = function( a ) {
    return {
        next: $jscomp.arrayIteratorImpl( a )
    };
};

// makeIterator
$jscomp.makeIterator = function( a ) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];

    if( b )
        return b.call( a );

    if( "number" == typeof a.length )
        return $jscomp.arrayIterator( a );

    throw Error( String( a ) + " is not an iterable or ArrayLike" );
};

// arrayFromIterator
$jscomp.arrayFromIterator = function( l ) {
    for( var e, B = []; !( e = l.next() ).done; )
    {
        B.push( e.value );
    }

    return B;
};

// arrayFromIterable
$jscomp.arrayFromIterable = function( l ) {
    return l instanceof Array ? l : $jscomp.arrayFromIterator( $jscomp.makeIterator( l ) );
};

// generator.ensureIteratorResultIsObject_
$jscomp.generator.ensureIteratorResultIsObject_ = function( a ) {
    if( !( a instanceof Object ) )
        throw new TypeError( "Iterator result " + a + " is not an object" );
};

// generator.Context
$jscomp.generator.Context = function() {
    this.isRunning_ = !1;
    this.yieldAllIterator_ = null;
    this.yieldResult = void 0;
    this.nextAddress = 1;
    this.finallyAddress_ = this.catchAddress_ = 0;
    this.finallyContexts_ = this.abruptCompletion_ = null;
};

// generator.Context.prototype.start_
$jscomp.generator.Context.prototype.start_ = function() {
    if( this.isRunning_ )
        throw new TypeError( "Generator is already running" );

    this.isRunning_ = !0;
};

// generator.Context.prototype.stop_
$jscomp.generator.Context.prototype.stop_ = function() {
    this.isRunning_ = !1;
};

// generator.Context.prototype.jumpToErrorHandler_
$jscomp.generator.Context.prototype.jumpToErrorHandler_ = function() {
    this.nextAddress = this.catchAddress_ || this.finallyAddress_;
};

// generator.Context.prototype.next_
$jscomp.generator.Context.prototype.next_ = function( a ) {
    this.yieldResult = a;
};

// generator.Context.prototype.throw_
$jscomp.generator.Context.prototype.throw_ = function( a ) {
    this.abruptCompletion_ = {
        exception:a,
        isException:!0
    };

    this.jumpToErrorHandler_();
};

// generator.Context.prototype.return
$jscomp.generator.Context.prototype.return = function( a ) {
    this.abruptCompletion_ = {
        return:a
    };

    this.nextAddress = this.finallyAddress_;
};

// generator.Context.prototype.jumpThroughFinallyBlocks
$jscomp.generator.Context.prototype.jumpThroughFinallyBlocks = function( a ) {
    this.abruptCompletion_ = {
        jumpTo:a
    };

    this.nextAddress = this.finallyAddress_;
};

// generator.Context.prototype.yield
$jscomp.generator.Context.prototype.yield = function( a, b ) {
    this.nextAddress = b;
    
    return {
        value:a
    };
};

// generator.Context.prototype.yieldAll
$jscomp.generator.Context.prototype.yieldAll = function( a, b ) {
    a = $jscomp.makeIterator( a );

    var c = a.next();

    $jscomp.generator.ensureIteratorResultIsObject_( c );

    if( c.done )
        this.yieldResult = c.value, this.nextAddress = b;
    else
        return this.yieldAllIterator_ = a, this.yield( c.value, b );
};

// generator.Context.prototype.jumpTo
$jscomp.generator.Context.prototype.jumpTo = function( a ) {
    this.nextAddress = a;
};

// generator.Context.prototype.jumpToEnd
$jscomp.generator.Context.prototype.jumpToEnd = function() {
    this.nextAddress = 0;
};

// generator.Context.prototype.setCatchFinallyBlocks
$jscomp.generator.Context.prototype.setCatchFinallyBlocks = function( a, b ) {
    this.catchAddress_ = a;

    void 0 != b && ( this.finallyAddress_ = b );
};

// generator.Context.prototype.setFinallyBlock
$jscomp.generator.Context.prototype.setFinallyBlock = function( a ) {
    this.catchAddress_ = 0;
    this.finallyAddress_ = a || 0;
};

// generator.Context.prototype.leaveTryBlock
$jscomp.generator.Context.prototype.leaveTryBlock = function( a, b ) {
    this.nextAddress = a;
    this.catchAddress_ = b || 0;
};

// generator.Context.prototype.enterCatchBlock
$jscomp.generator.Context.prototype.enterCatchBlock = function( a ) {
    this.catchAddress_ = a || 0;
    a = this.abruptCompletion_.exception;
    this.abruptCompletion_ = null;
    return a;
};

// generator.Context.prototype.enterFinallyBlock
$jscomp.generator.Context.prototype.enterFinallyBlock = function( a, b, c ) {
    c ? this.finallyContexts_[c] = this.abruptCompletion_ : this.finallyContexts_ = [this.abruptCompletion_];
    this.catchAddress_ = a || 0;
    this.finallyAddress_ = b || 0;
};

// generator.Context.prototype.leaveFinallyBlock
$jscomp.generator.Context.prototype.leaveFinallyBlock = function( a, b ) {
    b = this.finallyContexts_.splice( b || 0 )[0];

    if( b = this.abruptCompletion_ = this.abruptCompletion_ || b )
    {
        if( b.isException )
            return this.jumpToErrorHandler_();

        void 0 != b.jumpTo && this.finallyAddress_ < b.jumpTo ? ( this.nextAddress = b.jumpTo, this.abruptCompletion_ = null ) : this.nextAddress = this.finallyAddress_;
    }
    else
        this.nextAddress = a;
};

// generator.Context.prototype.forIn
$jscomp.generator.Context.prototype.forIn = function( a ) {
    return new $jscomp.generator.Context.PropertyIterator( a );
};

// generator.Context.PropertyIterator
$jscomp.generator.Context.PropertyIterator = function( a ) {
    this.object_ = a;
    this.properties_ = [];

    for( var b in a )
        this.properties_.push( b );

    this.properties_.reverse();
};

// generator.Context.PropertyIterator.prototype.getNext
$jscomp.generator.Context.PropertyIterator.prototype.getNext = function() {
    for( ; 0 < this.properties_.length; )
    {
        var a = this.properties_.pop();

        if( a in this.object_ )
            return a;
    }

    return null;
};

// generator.Engine_
$jscomp.generator.Engine_ = function( a ) {
    this.context_ = new $jscomp.generator.Context;
    this.program_ = a;
};

// generator.Engine_.prototype.next_
$jscomp.generator.Engine_.prototype.next_ = function( a ) {
    this.context_.start_();

    if( this.context_.yieldAllIterator_ )
        return this.yieldAllStep_( this.context_.yieldAllIterator_.next, a, this.context_.next_ );

    this.context_.next_( a );

    return this.nextStep_();
};

// generator.Engine_.prototype.return_
$jscomp.generator.Engine_.prototype.return_ = function( a ) {
    this.context_.start_();

    var b = this.context_.yieldAllIterator_;

    if( b )
        return this.yieldAllStep_( "return" in b ? b["return"] : function( c ) {
            return {
                value: c,
                done: !0
            }
        }, a, this.context_.return );

    this.context_.return( a );

    return this.nextStep_();
};

// generator.Engine_.prototype.throw_
$jscomp.generator.Engine_.prototype.throw_ = function( a )
{
    this.context_.start_();
    
    if( this.context_.yieldAllIterator_ )
        return this.yieldAllStep_( this.context_.yieldAllIterator_["throw"], a, this.context_.next_ );

    this.context_.throw_( a );

    return this.nextStep_();
};

// generator.Engine_.prototype.yieldAllStep_
$jscomp.generator.Engine_.prototype.yieldAllStep_ = function( a, b, c ) {
    try {
        var d = a.call( this.context_.yieldAllIterator_, b );

        $jscomp.generator.ensureIteratorResultIsObject_( d );

        if( !d.done )
            return this.context_.stop_() , d;

        var e = d.value
    }
    catch( f ) {
        return this.context_.yieldAllIterator_ = null, this.context_.throw_( f ), this.nextStep_()
    }

    this.context_.yieldAllIterator_ = null;
    c.call( this.context_, e );

    return this.nextStep_();
};

// generator.Engine_.prototype.nextStep_
$jscomp.generator.Engine_.prototype.nextStep_ = function() {
    for( ; this.context_.nextAddress; )
    {
        try {
            var a = this.program_( this.context_ );

            if( a )
                return this.context_.stop_(), {
                    value: a.value,
                    done: !1
                }
        }
        catch( b ) {
            this.context_.yieldResult = void 0, this.context_.throw_( b );
        }
    }

    this.context_.stop_();

    if( this.context_.abruptCompletion_ )
    {
        a = this.context_.abruptCompletion_;
        this.context_.abruptCompletion_ = null;

        if( a.isException )
            throw a.exception;

        return {
            value: a.return,
            done: !0
        }
    }

    return {
        value: void 0,
        done: !0
    }
};

// generator.Generator_
$jscomp.generator.Generator_ = function( a ) {
    this.next = function( b ) {
        return a.next_( b )
    };

    this.throw = function( b ) {
        return a.throw_( b )
    };

    this.return = function( b ) {
        return a.return_( b )
    };

    this[Symbol.iterator] = function() {
        return this
    }
};

// generator.createGenerator
$jscomp.generator.createGenerator = function( a, b ) {
    b = new $jscomp.generator.Generator_( new $jscomp.generator.Engine_( b ) );

    $jscomp.setPrototypeOf && a.prototype && $jscomp.setPrototypeOf( b, a.prototype );
    return b
};

// asyncExecutePromiseGenerator
$jscomp.asyncExecutePromiseGenerator = function( a ) {
    function b( d ) {
        return a.next( d )
    }
    function c( d ) {
        return a.throw( d )
    }

    return new Promise( function( d, e ) {
        function f( h ) {
            h.done ? d( h.value ) : Promise.resolve( h.value ).then( b, c ).then( f, e )
        }

        f( a.next() )
    })
};

// asyncExecutePromiseGeneratorFunction
$jscomp.asyncExecutePromiseGeneratorFunction = function( a ) {
    return $jscomp.asyncExecutePromiseGenerator( a() )
};

// asyncExecutePromiseGeneratorProgram
$jscomp.asyncExecutePromiseGeneratorProgram = function( a ) {
    return $jscomp.asyncExecutePromiseGenerator( new $jscomp.generator.Generator_( new $jscomp.generator.Engine_( a ) ) )
};

// objectCreate
$jscomp.objectCreate = $jscomp.ASSUME_ES5 || "function" == typeof Object.create ? Object.create : function( k ) {
    var r = function(){};
    r.prototype = k;

    return new r;
};

// getConstructImplementation
$jscomp.getConstructImplementation = function() {
    function k() {
        function t() {};
        new t;
        Reflect.construct( t, [], function(){} );
        return new t instanceof t;
    }

    if( $jscomp.TRUST_ES6_POLYFILLS && "undefined" != typeof Reflect && Reflect.construct )
    {
        if( k() )
            return Reflect.construct;

        var r = Reflect.construct;

        return function( t, z, y ) {
            t = r( t, z );
            y && Reflect.setPrototypeOf( t, y.prototype );
            return t;
        }
    }

    return function( t, z, y ) {
        void 0 === y && ( y = t );
        y = $jscomp.objectCreate( y.prototype || Object.prototype );
        return Function.prototype.apply.call( t, y, z ) || y;
    }
};

// construct
$jscomp.construct = {
    valueOf: $jscomp.getConstructImplementation
}.valueOf();

// inherits
$jscomp.inherits = function( k, r ) {
    k.prototype = $jscomp.objectCreate( r.prototype );
    k.prototype.constructor = k;

    if( $jscomp.setPrototypeOf )
    {
        var t = $jscomp.setPrototypeOf;
        t( k, r )
    }
    else
    {
        for( t in r )
        {
            if( "prototype" != t )
            {
                if( Object.defineProperties )
                {
                    var z = Object.getOwnPropertyDescriptor( r, t );
                    z && Object.defineProperty( k, t, z )
                }
                else
                {
                    k[t] = r[t];
                }
            }
        }
    }

    k.superClass_ = r.prototype
};

define("modules/polyfills", function(){});
